import React, { useEffect, useRef } from "react";
import { SIGNUP_SCRIPT_URL } from "../../config/config";

// Mount the signup script
export default function SignupEmbed({
  title,
  subtitle,
  size = "large",
  maxWidth = 504,
  flush = false,
  demoUrl,
  campaign,
  backendUrl,
  appUrl,
}) {
  const mountRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    const script = document.createElement("script");
    script.src = SIGNUP_SCRIPT_URL;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
      // let the script mount again if the page comes back
      if (mount) {
        mount.innerHTML = "";
        mount.removeAttribute("data-as-mounted");
      }
    };
  }, []);

  return (
    <div
      id="aisensy-wa-signup"
      ref={mountRef}
      data-title={title}
      data-subtitle={subtitle}
      data-size={size}
      data-max-width={maxWidth}
      data-flush={flush ? "true" : undefined}
      data-demo-url={demoUrl}
      data-campaign={campaign}
      data-backend-url={backendUrl}
      data-app-url={appUrl}
    />
  );
}
